const RenderWebGL = require('./RenderWebGL');

/**
 * Export for NPM & Node.js
 * @type {RenderWebGL}
 */
module.exports = RenderWebGL;



//////////////////
// WEBPACK FOOTER
// ./node_modules/scratch-render/src/index.js
// module id = wh4x
// module chunks = 0